export const waiterPageInitialState = {
  activeOrder: ''
};

export const waiterPageActions = {
  SET_ACTIVE_ORDER: (state: any, payload: any) => {
    return { ...state, activeOrder: payload };
  }
};
